/**
 * PATH: packages/email-hub/src/feature/action-signals/types.ts
 * FILE_ID: EMAILHUB-ACTIONSIGNALS-TYPES-001
 * PURPOSE: Generated, detail-only contract helpers for email action signals.
 * WHY: Sensitive values stay out of list payloads while their detail schema
 *      remains mechanically pinned to the backend OpenAPI contract.
 */
import type { BackendSchemas } from '@quotech/api'

import type { Email } from '../hooks/useEmails'

export type EmailActionSignalKind = BackendSchemas['EmailActionSignalKindEnum']
export type EmailActionSignal = BackendSchemas['EmailActionSignal']

type EmailActionSignalCarrier = Email & {
  action_signals?: EmailActionSignal[] | null
}

/** Detail/thread payloads opt into this field; list payloads do not. */
export function actionSignalsForEmail(email: Email): EmailActionSignal[] {
  const signals = (email as EmailActionSignalCarrier).action_signals
  return Array.isArray(signals) ? signals : []
}

export function verificationCodeSignalFor(email: Email): EmailActionSignal | null {
  return (
    actionSignalsForEmail(email).find(
      (signal) => signal.kind === 'verification_code',
    ) ?? null
  )
}

export function invoiceNumberSignalFor(email: Email): EmailActionSignal | null {
  return (
    actionSignalsForEmail(email).find(
      (signal) => signal.kind === 'invoice_number',
    ) ?? null
  )
}
